module.exports = __webpack_public_path__ + "static/media/flossyfresh-1.accc0312.jpg";